const normalizeText = (value = "") =>
    String(value)
        .toLowerCase()
        .replace(/ё/g, "е")
        .replace(/[!?.,;:()[\]{}"«»'`–—-]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const LOCAL_RULES = [
    {
        id: "greeting",
        matches: [
            /^привет$/,
            /^здравствуй(те)?$/,
            /^добр(ый|ое)\s+(день|утро|вечер)$/,
            /^хай$/,
        ],
        answer:
            "Здравствуйте! Я ИИ-помощник Прохор. Могу подсказать по личному кабинету " +
            "и ответить на вопросы из Базы знаний по эмоциональному интеллекту. " +
            "С чем помочь?",
    },
    {
        id: "thanks",
        matches: [/^спасибо$/, /^благодарю$/, /^спс$/, /^thanks$/],
        answer: "Пожалуйста! Если будут ещё вопросы — спросите, я рядом.",
    },
    {
        id: "what-can-you-do",
        matches: [
            /что\s+ты\s+умеешь/,
            /что\s+умеет(е)?\s+помощник/,
            /твои\s+возможност/,
            /что\s+можешь/,
            /чем\s+ты\s+поможешь/,
        ],
        answer:
            "Я помогаю двумя вещами:\n" +
            "1) Подсказываю, что и как сделать в личном кабинете — с учётом вашей роли.\n" +
            "2) Отвечаю на вопросы из Базы знаний по эмоциональному интеллекту.\n\n" +
            "Просто задайте вопрос в чате.",
    },
    {
        id: "help",
        matches: [/^помощ(ь|и)$/, /^help$/, /^нужна\s+помощь$/],
        answer:
            "Конечно. Сформулируйте, пожалуйста, вопрос — например, «как пригласить сотрудников» " +
            "или «где посмотреть отчёт».",
    },
    {
        id: "doc-info-general",
        matches: [
            /какая?\s+есть\s+информац(ия|ии)\s+в\s+документе/,
            /что\s+есть\s+в\s+документе/,
            /какая?\s+информац(ия|ии)\s+в\s+документе/,
        ],
        answer:
            "Я могу подсказать по материалам из Базы знаний. Уточните тему документа " +
            'или задайте конкретный вопрос, например: «Какие выводы по эмоциональному ' +
            'интеллекту в документе?»',
    },
    {
        id: "very-short",
        matches: [
            /^какая?\s+есть\??$/,
            /^что\s+есть\??$/,
            /^что\s+есть$/,
            /^как$/,
            /^где$/,
            /^а$/,
            /^ну$/,
            /^ок(ей)?$/,
        ],
        answer:
            "Чтобы помочь точнее, уточните вопрос — например: «как начать», " +
            "«как выдать тест», «как назначить доступы» или «где отчёт».",
    },
    {
        id: "do-not-understand",
        matches: [
            /не\s+понимаю/,
            /не\s+понял/,
            /не\s+поняла/,
            /^неясно$/,
            /непонятн/,
        ],
        answer:
            "Давайте по-другому. Задайте, пожалуйста, конкретный вопрос — например: " +
            "«как начать», «как назначить доступы», «как выдать тест» или «где мои результаты».",
    },
    {
        id: "who-are-you",
        matches: [
            /кто\s+ты/,
            /как\s+тебя\s+зовут/,
            /ты\s+кто/,
            /ты\s+бот/,
            /ты\s+искусственн/,
        ],
        answer:
            "Меня зовут Прохор, я ИИ-помощник внутри кабинета. Подсказываю по навигации " +
            "и отвечаю на вопросы из Базы знаний по эмоциональному интеллекту.",
    },
];

export const getLocalProhorReply = (question) => {
    const normalized = normalizeText(question);
    if (!normalized) return null;

    const rule = LOCAL_RULES.find(({ matches }) =>
        matches.some((pattern) => pattern.test(normalized))
    );

    if (!rule) return null;

    return {
        ruleId: rule.id,
        text: rule.answer,
    };
};
